module.exports = __webpack_public_path__ + "static/media/måling.f4199878.m4a";